
function VerticalFormElementWrapper({children, className = ""}) {

    return <div className={"form-field form-field-vertical " + className}>
        {children}
    </div>

}

function HorizontalFormElementWrapper({children, className = ""}) {

    return <div className={"form-field form-field-horizontal " + className}>
        {children}
    </div>

}

export default function FormElementWrapper({children, type = "vertical", className = ""}) {

    let wrapper;

    if (type === "vertical") {

        wrapper = (<VerticalFormElementWrapper className={className}>
            {children}
        </VerticalFormElementWrapper>);

    } else {

        wrapper = (<HorizontalFormElementWrapper className={className}>
            {children}
        </HorizontalFormElementWrapper>);

    }

    return wrapper;

}